import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { twMerge } from "tailwind-merge";
import MemberImage from "@components/parliament/member-image";
import type { MemberListEntry } from "@lib/api/member/types";
import { routes } from "@lib/navigation";
interface Props {
  member: MemberListEntry;
}
export default function MemberCard(t0) {
  const $ = _c(26);
  const {
    member
  } = t0;
  let t1;
  if ($[0] !== member.id) {
    t1 = routes.member(member.id);
    $[0] = member.id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = twMerge("relative flex rounded-sm p-4 shadow-md", "bg-white dark:bg-slate-800");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="font-medium">Valkrets</div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== member.district) {
    t4 = <div>{member.district}</div>;
    $[4] = member.district;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mt-2 font-medium">Ålder</div>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== member.age) {
    t6 = <div>{member.age}</div>;
    $[7] = member.age;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t4 || $[10] !== t6) {
    t7 = <div className="mb-10">{t3}{t4}{t5}{t6}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== member.firstName || $[13] !== member.lastName || $[14] !== member.party || $[15] !== member.pictureUrl) {
    t8 = <MemberImage imageUrl={member.pictureUrl} firstName={member.firstName} lastName={member.lastName} party={member.party} sizes="(min-width: 640px) 160px, 128px" className="mb-1 ml-auto h-32 w-32 sm:h-40 sm:w-40" />;
    $[12] = member.firstName;
    $[13] = member.lastName;
    $[14] = member.party;
    $[15] = member.pictureUrl;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = twMerge("absolute bottom-0 left-0 w-full rounded-b p-2 text-slate-50", "bg-slate-600/70 backdrop-blur-xs dark:bg-slate-900/75");
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== member.firstName || $[19] !== member.lastName) {
    t10 = <div className={t9}>{member.firstName} {member.lastName}</div>;
    $[18] = member.firstName;
    $[19] = member.lastName;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t1 || $[22] !== t10 || $[23] !== t7 || $[24] !== t8) {
    t11 = <Link href={t1} className={t2}>{t7}{t8}{t10}</Link>;
    $[21] = t1;
    $[22] = t10;
    $[23] = t7;
    $[24] = t8;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  return t11;
}